import { A_01, OTHER_DEFAULTS } from "@stadium/shared/src/helpers/plasmic/static-slices";

export const A01_PLASMIC_PROPS = {
  heading: {
    type: "string",
    defaultValue: OTHER_DEFAULTS[A_01].heading,
  },
  faq: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        question: {
          type: "string",
        },
        answer: {
          type: "string",
        },
      },
    },
    defaultValue: OTHER_DEFAULTS[A_01].faq,
    description: "Faq array (A01 only)",
  },
  className: {
    type: "class",
    defaultValue: "",
  },
};
